"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Chegg = window.Chegg || {};

if (!window.Chegg) window.Chegg = Chegg;

if (!Chegg.urls) Chegg.urls = {};
if (!window.configs) window.configs = {};
if (!Chegg.global_configs) Chegg.global_configs = {};

window.Chegg = Chegg;

Chegg.urls.site_url = "http://trunk.live.test.cheggnet.com";

exports.Chegg = Chegg;


//////////////////
// WEBPACK FOOTER
// ./~/ereader-core/dist/Chegg.js
// module id = 648
// module chunks = 0